import { use } from "react"
import { ConfigContext } from "@/utils"

export function useConfig() {
  return use(ConfigContext)
}
